import React from 'react';
// Analytics
import { usePageTracking } from '../../hooks/useAnalytics';
// Components
import Navbar from '../../components/nav/Navbar';
import FooterComponent from '../../components/footer/FooterComponent';
import HomePageMainContainer from '../../components/home/HomePageMainContainer';
import TopBarCta from '../../components/cta/TopBarCta';
import HomePageHeader from '../../components/home/HomePageHeader';
import BottomBar from '../../components/cta/BottomBar';

const HomePage = React.memo(() => {
  usePageTracking();

  return (
    <>
      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour3 text-colour2 dark:bg-colour2 dark:text-colour1 font-poppins'>
        <div className='grid'>
          <div className='grid grid-rows-[auto_auto_auto_1fr] lg:min-h-screen'>
            {/* Top bar */}
            <TopBarCta />

            {/* Navigation */}
            <Navbar />

            {/* Small bar */}
            <BottomBar />

            {/* Header */}
            <HomePageHeader />
          </div>

          {/* Main page content */}
          <HomePageMainContainer />

          {/* Footer */}
          <FooterComponent />
        </div>
      </div>
    </>
  );
});

export default HomePage;
